import { style } from '@primeuix/styles/blockui';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-blockui'
};
var BlockUIStyle = BaseStyle.extend({
  name: 'blockui',
  style: style,
  classes: classes
});

export { BlockUIStyle as default };
//# sourceMappingURL=index.mjs.map
